import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu", "icon", "trigger"]

    connect() {
        this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    }

    toggle() {
        if (this.menuTarget.classList.contains("hidden")) {
            this.open()
        } else {
            this.close()
        }
    }

    open() {
        this.menuTarget.classList.remove("hidden")
        if (this.hasIconTarget) {
            this.iconTarget.classList.add("rotate-180")
        }
        // Without this the button announces itself as collapsed while its panel
        // is open, so keyboard and screen reader users get no state at all.
        if (this.hasTriggerTarget) {
            this.triggerTarget.setAttribute("aria-expanded", "true")
        }
        document.addEventListener("click", this.closeOnClickOutside)
    }

    close() {
        this.menuTarget.classList.add("hidden")
        if (this.hasIconTarget) {
            this.iconTarget.classList.remove("rotate-180")
        }
        if (this.hasTriggerTarget) {
            this.triggerTarget.setAttribute("aria-expanded", "false")
        }
        document.removeEventListener("click", this.closeOnClickOutside)
    }

    closeOnClickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    disconnect() {
        document.removeEventListener("click", this.closeOnClickOutside)
    }
}
